import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@bitcoin-portal/bitcoincom-pkg-components/dist/Button';
import Link from '@bitcoin-portal/bitcoincom-pkg-components/dist/Link';
import { Content, Logo, Wrapper } from './styled';
import { useBranchFallback } from '../hooks/useBranchFallback';
import logoBlack from '../assets/logo_black.png';
import StickyContainer from './StickyContainer';
import Intl from '../i18n/navbarV2';
const NavbarV2 = ({ link = 'https://branch.wallet.bitcoin.com/NC6NvJpeVzb', locale = 'en', }) => {
    const [sticky, setSticky] = useState(false);
    const buttonLink = useBranchFallback({
        branch: link,
        android: 'https://play.google.com/store/apps/details?id=com.bitcoin.mwallet',
        iOS: 'https://apps.apple.com/us/app/bitcoin-crypto-defi-wallet/id1252903728?ls=1',
        fallback: 'https://wallet.bitcoin.com/',
    });
    return (React.createElement(Intl, { locale: locale },
        React.createElement(StickyContainer, { setSticky: setSticky },
            React.createElement(Wrapper, { sticky: sticky },
                React.createElement(Content, null,
                    React.createElement(Link, { href: "https://www.bitcoin.com/" },
                        React.createElement(Logo, { src: logoBlack, alt: "Bitcoin.com" })),
                    React.createElement(Button, { design: Button.Designs.Primary, href: buttonLink, size: Button.Sizes.Small },
                        React.createElement(FormattedMessage, { id: "navbar.button" })))))));
};
export default NavbarV2;
//# sourceMappingURL=NavbarV2.js.map